module.exports = __webpack_public_path__ + "static/media/home-hero--bg-newzealand.399045fb.jpg";